import React from 'react';
import { Box } from '@mui/material';
import { Screen } from 'src/components/screen';
import { DashboardHeader } from '../engagement/components/header/header';
import { useWindowDimensions } from 'src/utils/ui/dimensions';
import { CheckinsProvider } from './checkins-context';
import { container as reviewsContainer } from '../engagement/reviews/styles';
import { CheckinsPanel } from './components/checkins-panel';

const CheckinsScreen: React.FC = () => {
  const { height } = useWindowDimensions();

  return (
    <Screen>
      <CheckinsProvider>
        <Box sx={{ ...reviewsContainer, minHeight: height }}>
          <DashboardHeader />

          <CheckinsPanel />
        </Box>
      </CheckinsProvider>
    </Screen>
  );
};

export { CheckinsScreen };
